import "./styles.scss";

const BackArrowIcon = () => (
  <svg className="phaseNavigation__backIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
  </svg>
);

const PhaseNavigation = ({ sections = [], activeIndex = 0, onChangeSection, onBack }) => {
  return (
    <nav className="phaseNavigation">
      <div className="phaseNavigation__inner">
        <button type="button" className="phaseNavigation__back" onClick={onBack}>
          <BackArrowIcon />
          Main Menu
        </button>

        <div className="phaseNavigation__tabs">
          {sections.map((section, index) => {
            const isActive = index === activeIndex;
            return (
              <button
                key={section.sectionId}
                type="button"
                className={`phaseNavigation__tab${isActive ? " phaseNavigation__tab--active" : ""}`}
                onClick={() => onChangeSection && onChangeSection(index)}
              >
                <span>{section.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default PhaseNavigation;
